module.exports = __webpack_public_path__ + "img/img65.c0ceac08.svg";